// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Json_decode from "../../../../../../../node_modules/@glennsl/bs-json/src/Json_decode.bs.js";
import * as ResponseHandler$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseHandler.bs.js";

function decodeErrorMessage(json) {
  return /* DefaultError */{
          _0: {
            title: {
              TAG: /* UnprocessedEntity */1,
              _0: undefined
            },
            message: Json_decode.field("message", Json_decode.string, json)
          }
        };
}

function decodeSurgeUnprocessedError(json) {
  return List.nth(Json_decode.field("error", (function (param) {
                    return Json_decode.list(decodeErrorMessage, param);
                  }), json), 0);
}

function execute(data) {
  if (typeof data === "number" || data.TAG !== /* UnprocessedEntity */2) {
    return ResponseHandler$Catalyst.DefaultErrorConverter.execute(data);
  } else {
    return decodeSurgeUnprocessedError(data._0);
  }
}

export {
  decodeErrorMessage ,
  decodeSurgeUnprocessedError ,
  execute ,
  
}
/* ResponseHandler-Catalyst Not a pure module */
